module.exports = __webpack_public_path__ + "img/sell.1ac0f7ff.png";